module.exports = "/_next/static/images/tutorial_2-5347b5b91a5853970ec91ce12aeb810c.svg";